import React from "react";
import { useState, useEffect } from "react";

import { Navigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

import { getRequest } from "../../api/axiosRequests";
import CardAdminUser from "../components/CardAdminUser";
import UserForm from "../components/UserForm";
import SearchBar from "../../common/components/SearchBar";
import IconUsersActive from "../../common/images/iconUsersActive.png";
import { PALETTE } from "../../common/ThemeConstants";

export default function AdminUsers() {
  const [logged, setLogged] = useState(true);
  const [loggedUser, setLoggedUser] = useState({});
  const [users, setUsers] = useState([]);
  const [nUserPremium, setNUserPremium] = useState(0);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState({ id: -1 });
  const [showEditForm, setShowEditForm] = useState(false);

  // API Requests
  async function fetchRole() {
    try {
      const headers = { Authorization: localStorage.getItem("jwt") };
      const response = await getRequest("userData/", headers);
      const user = response.data["data"];
      const role = await response.data["role"];
      if (role === "Admin") {
        setLogged(true);
        setLoggedUser(user);
      } else {
        setLogged(false);
      }
    } catch (err) {
      setLogged(false);
    }
  }

  async function fetchUsers() {
    const headers = { Authorization: localStorage.getItem("jwt") };

    const isValid = (sub) => {
      const now = new Date();
      const start_at = new Date(sub.start_at);
      const expire_at = new Date(sub.expire_at);
      return (
        start_at.getTime() <= now.getTime() &&
        expire_at.getTime() >= now.getTime()
      );
    };

    const userListPromise = getRequest("userList/", headers);
    const userSubscriptionsPromise = getRequest("userSubscriptions/", headers);
    let usersPremium = 0;
    Promise.all([userListPromise, userSubscriptionsPromise])
      .then((values) => {
        const usersData = values[0]["data"];
        const subscriptionsData = values[1]["data"];
        usersData.map((user) => {
          const subscriptions = subscriptionsData.filter(
            (sub) => sub.user === user.id && isValid(sub)
          );
          user["premium"] = subscriptions.length > 0;
          usersPremium += subscriptions.length > 0 ? 1 : 0;
        });
        setNUserPremium(usersPremium);
        setUsers(usersData);
        setFilteredUsers(usersData);
        setLogged(true);
      })
      .catch((err) => {
        setLogged(false);
      });
  }

  // Button's Callbacks
  const showEditFormCallback = () => {
    setCurrentUser({ id: -1 });
    setShowEditForm(true);
  };

  const closeEditFormCallback = () => {
    setShowEditForm(false);
  };

  const editCallback = (idUser) => {
    const currentUser = users.filter((u) => u.id === idUser)[0];
    setCurrentUser(currentUser);
    setShowEditForm(true);
  };

  const onSearchChange = (name) => {
    const nameLowerCase = name.toLowerCase();
    const filtered = users.filter(
      (u) =>
        u.firstname.toLowerCase().includes(nameLowerCase) ||
        u.lastname.toLowerCase().includes(nameLowerCase) ||
        u.email.toLowerCase().includes(nameLowerCase)
    );
    setFilteredUsers(filtered);
  };

  // OnMount DOM
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchRole();
    fetchUsers();
  }, []);

  return (
    <>
      {!logged && <Navigate to="/" />}
      {logged && (
        <Container className="mt-2" style={{ paddingBottom: 10 }}>
          <UserForm
            getCurrentUser={() => {
              return currentUser;
            }}
            onHide={closeEditFormCallback}
            show={showEditForm}
            onSubmit={() => {
              fetchUsers();
            }}
          />
          <div className="mb-3 mt-2">
            <div className="rounded-md shadow-sm align-self-center text-center py-3">
              <Row
                className="m-auto"
                style={{ color: PALETTE.DARKGRAY, width: "100%" }}
              >
                <Col xs={3} className="align-self-center text-center">
                  <img
                    src={IconUsersActive}
                    alt={"Users"}
                    style={{ width: "2rem" }}
                  />
                </Col>
                <Col xs={9}>
                  <Row className="my-1">
                    <Col>
                      <span className="text-center">Users</span>
                    </Col>
                    <Col>
                      <span className="text-center">Premium</span>
                    </Col>
                    <Col>
                      <span className="text-center">Free</span>
                    </Col>
                  </Row>
                  <Row style={{ fontWeight: "bold" }}>
                    <Col>
                      <span className="text-center">{users.length}</span>
                    </Col>
                    <Col>
                      <span className="text-center">{nUserPremium}</span>
                    </Col>
                    <Col>
                      <span className="text-center">
                        {users.length - nUserPremium}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
          <div className="align-self-center text-center">
            <SearchBar
              onChange={onSearchChange}
              addButton={true}
              onAdd={showEditFormCallback}
            />
            <div style={{ width: "100%" }}>
              <div className="my-3">
                {filteredUsers.map(
                  (user, idUser) =>
                    loggedUser.id != user.id && (
                      <div key={user.id}>
                        <CardAdminUser
                          height={80}
                          user={user}
                          isAdmin={loggedUser.id == user.id}
                          isActive={false}
                          editCallback={editCallback}
                        />
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </Container>
      )}
    </>
  );
}
